// Global Instructions Rule Applied!
//
// InvestmentsTab — configurable per-fund Investment Detail grid. Renders the
// FundInvestmentDetailTable with an Aggregations builder. Fund identity
// (fundName for the export filename) comes from the same `detail` payload
// the Dashboard tab uses.

import React from 'react'
import FundInvestmentDetailTable from '../../FundInvestmentDetailTable.tsx'

interface InvestmentsTabProps {
  fundId: string | null
  detail?: Record<string, unknown> | null
}

export default function InvestmentsTab({ fundId, detail }: InvestmentsTabProps): React.ReactElement {
  const fundName = typeof detail?.funds__name === 'string' ? (detail.funds__name as string) : null
  return (
    <div className='h-full p-3'>
      <FundInvestmentDetailTable fundId={fundId} fundName={fundName} />
    </div>
  )
}
